export default __webpack_public_path__ + "static/banner-how-to-improve-the-value-of-your-car-8e6110d3832bde20a9edc5f93c5bc911.jpg";